import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiErrorDetail } from "@/lib/api";
import { t, useLanguage } from "@/lib/i18n";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function TreeRequestSettings() {
  useLanguage();
  const { user } = useAuth();
  const [settings, setSettings] = useState(null), [message, setMessage] = useState(""), [busy, setBusy] = useState(false);
  useEffect(() => { if (user?.role === "admin") api.get("/settings/tree-requests").then(({ data }) => setSettings(data)).catch((error) => setMessage(formatApiErrorDetail(error.response?.data?.detail) || "Could not load settings. Please reload.")); }, [user?.role]);
  if (user?.role !== "admin") return <Navigate to="/app" replace />;
  return <section className="max-w-xl mx-auto space-y-4">
    <h2 className="font-serif text-3xl">{t("Tree Request Settings")}</h2>
    <p>{t("Limit the number of existing members edited in one whole-tree request. Zero allows additions only. The combined limit is 100 new or edited members. Pending requests keep the limits used when submitted.")}</p>
    {message && <p role="status">{t(message)}</p>}
    {settings && <form className="rounded-xl border bg-white p-5 space-y-4" onSubmit={async (event) => {
      event.preventDefault(); setBusy(true); setMessage("");
      try { const { data } = await api.put("/settings/tree-requests", { max_edited_members: Number(settings.max_edited_members) }); setSettings(data); setMessage("Tree request limits saved."); }
      catch (error) { setMessage(formatApiErrorDetail(error.response?.data?.detail) || "Could not save limits."); } finally { setBusy(false); }
    }}>
      <Label htmlFor="max-edited-members">{t("Maximum edited existing members per tree request")}</Label>
      <Input id="max-edited-members" type="number" required min="0" max="100" step="1" disabled={busy} value={settings.max_edited_members} onChange={(event) => setSettings({ ...settings, max_edited_members: event.target.value })} />
      <Button disabled={busy}>{t(busy ? "Saving..." : "Save limits")}</Button>
    </form>}
  </section>;
}
